import React, { useState } from "react";
import PageHead from "components/page-head";
import TaskBanner from "pages/opportunities/view/components/banner";
import styled from "styled-components";
import { Formik } from "formik";
import { maxQuery } from "utils/responsivenessHelper";
import api from "api";
import user from "containers/user";
import { successfulSaveNotification } from "utils/notifications";
import microtasks from "utils/microtaskMap";
import { MarketingFormLevel1, MarketingFormLevel2 } from "../form";
import validationSchema from "../form/validation-schema";
import _ from 'lodash';
import moment from 'moment';
import Modal, { ModalContent } from "components/modal";
import ConfirmEarnModal from "../modals/confirmEarn";
import IncompleteModal from "../modals/incomplete";
import SavedModal from "../modals/saved";
import { marketingQuestions } from "pages/biz-profile/dashboard/questions";
import SubmissionButtons from '../../shared/forms/SubmissionButtons';
import { navigate } from "@reach/router";
import routes from "utils/absoluteRoutes";

const AddContainer = styled.div`
  width: 100%;
`;

const ActionContextContainer = styled.div`
  display: none;
  ${maxQuery.both({ display: "flex" }, "850px")}

  button {
    width: 17em;
    margin: 0 auto;
  }
`;

const Section = styled.section`
  margin: 25px;
`;

const ButtonWrapper = styled.div`
  margin: 25px auto;
  button {
    min-width: 13.75em;
  }
`;

export const modals = {
  confirmEarn: "confirmEarn",
  incomplete: "incomplete",
  saved: "saved",
};

const Add = ({ location }) => {
  const { state: { data, taskStatuses, level } } = location;
  const questions = marketingQuestions[level];
  const taskStatus = !!taskStatuses ? taskStatuses[level] : {};
  const { my_uuid_id, partner_id, parent_partner_id } = user.state?.profile;

  const [showModal, setShowModal] = useState(null);
  const [confirmEarnProps, setConfirmEarnProps] = useState(null);
  const [initialData, setInitialData] = useState({
    ...questions,
    ..._.mapValues(data, obj => !!obj ? obj.value : ''),
  });
  const [isSubmitted, setIsSubmitted] = useState(taskStatus?.is_joined);
  const isCredited = taskStatus?.is_credited || false;
  
  async function onSave(values) {
    try {
      const filledValues = _.pickBy(values, (v, k) => !_.isNil(v) && !_.isEmpty(v));
      await api.business.setRequirement(parent_partner_id, partner_id, my_uuid_id, 'marketing', {
        ..._.mapValues(filledValues, v => {
          return {
            value: v,
            timestamp: moment().format()
          }
        })
      });

      successfulSaveNotification();
      navigate(routes.bizProfile);

    } catch (err) {
      console.error(err);
    }
  }

  async function submitDeed(values) {
    try {
      await onSave(values);
      const res = await api.tasks.join({
        opportunity: microtasks[`marketingLevel${level}`],
      });
      const { opt_in_code } = res?.record;
      await api.tasks.submitRequirement({
        opportunity: microtasks[`marketingLevel${level}`],
        unshaped_payload: values,
        status: 1,
        opt_in_code,
      });
      setShowModal(modals.saved);
      setIsSubmitted(true);
    } catch (err) {
      console.error(err);
    }
  }

  async function onClickSubmit(values) {
    const valuesForThisLevel = _.pick(values, _.keys(questions));
    if (_.every(_.values(valuesForThisLevel), val => !_.isEmpty(val) || (_.isEmpty(val) && _.isDate(val)))) {
      setShowModal(modals.confirmEarn);
      setConfirmEarnProps({ submitDeed, rewardAmount: 500, setShowModal, payload: values });
    } else {
      setShowModal(modals.incomplete);
    }
  }

  return (
    <AddContainer>
      <Formik
        initialValues={initialData}
        validationSchema={validationSchema}
        validateOnChange
        enableReinitialize
        onSubmit={onSave}
      >
        {({ handleSubmit, ...rest }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <Section>
              <TaskBanner 
                isOnRequirementPage
                onRedeem={() => onClickSubmit(rest.values)}
              />
            </Section>
            <PageHead
              title={`Marketing - Level ${level}`}
              subTitle={`Earn 500 Zlto when all fields submitted and verified.`}
            />
            {level === 1 && <MarketingFormLevel1 />}
            {level === 2 && <MarketingFormLevel2 />}
            <SubmissionButtons
              rest={rest}
              questions={questions}
              isSubmitted={isSubmitted}
              isCredited={isCredited}
              onClickSubmit={onClickSubmit}
            />
          </form>
        )}
      </Formik>
      {showModal && (
        <Modal onClose={() => setShowModal(null)}>
          <ModalContent>
            {showModal === modals.confirmEarn && <ConfirmEarnModal {...confirmEarnProps} />}
            {showModal === modals.incomplete && <IncompleteModal setShowModal={setShowModal} />}
            {showModal === modals.saved && <SavedModal setShowModal={setShowModal} />}
          </ModalContent>
        </Modal>
      )}
    </AddContainer>
  );
};

export default Add;
